var map = {
	"./2025-CoI-book-banner-short.jpg": 2529,
	"./2025-CoI-book-banner.jpg": 7788,
	"./2025-Contemp-Rom-book-banner-short.jpg": 961,
	"./2025-Contemp-Rom-book-banner.jpg": 3868,
	"./2025-KotR-book-banner-short.jpg": 9800,
	"./2025-KotR-book-banner.jpg": 8869,
	"./2025-LaGrange.jpg": 3227,
	"./2025-PP-book-banner-short.jpg": 3252,
	"./2025-PP-book-banner.jpg": 6441,
	"./2025-Timeline.jpg": 4833,
	"./2025-Upcoming-Books.jpg": 7951,
	"./2025-book-banner-short.jpg": 497,
	"./2025-book-banner.jpg": 5084,
	"./2025-reading-order.jpg": 5093,
	"./25-in-2025-poster.jpg": 7405,
	"./AuthorPinkHatRosewaterPic.jpg": 596,
	"./BookBrushImage-2026-3-16-23-482.jpg": 2636,
	"./COI-HoI-series-narrow.jpg": 6252,
	"./COI-HoI-series-wide.jpg": 4476,
	"./COI-PPC-series-narrow.jpg": 1183,
	"./COI-PPC-series-wide.jpg": 9831,
	"./Cards-with-Farathor-no-bkgd.png": 7431,
	"./CoI-series.jpg": 2111,
	"./CoI1-Back-Blurb.jpg": 8774,
	"./CoI1-COVER.jpg": 1830,
	"./CoI2-Back-Blurb.jpg": 4023,
	"./CoI2-COVER.jpg": 8541,
	"./CoI3-Back-Blurb.jpg": 4524,
	"./CoI3-COVER.jpg": 7608,
	"./CoI4-Back-Blurb.jpg": 9341,
	"./CoI4-COVER-title.jpg": 7078,
	"./CoI5-Back-blurb.jpg": 50,
	"./CoI5-COVER.jpg": 6586,
	"./CoI6-Back-blurb.jpg": 387,
	"./CoI6-COVER-placeholder.jpg": 1057,
	"./CoI6-COVER.jpg": 6721,
	"./CoI7-Back-blurb.jpg": 9864,
	"./CoI7-COVER-PLACEHOLDER.jpg": 4484,
	"./CoI8-COVER-PLACEHOLDER.jpg": 3151,
	"./Facebook_Logo_Primary.png": 8295,
	"./HP-Back-Blurb.jpg": 3562,
	"./HP-Math-Back-Blurb.jpg": 3369,
	"./Ivan-top-no-bkgd.png": 331,
	"./Jack-of-Spades-cover.jpg": 7490,
	"./JoS-backblurb.jpg": 9717,
	"./KS Banner.jpg": 4050,
	"./Karana-top-no-bkgd.png": 179,
	"./Kefen-only-no-bkgd.png": 111,
	"./KotR-HJ-banner-no-books.jpg": 4081,
	"./KotR-HJ-banner-with-books.jpg": 9224,
	"./KotR-MAIN-banner-no books.jpg": 4135,
	"./KotR-MAIN-banner-with books.jpg": 4014,
	"./KotR-Preq-OotW-Back-Blurb.jpg": 7543,
	"./KotR-Preq-OotW-COVER.jpg": 1245,
	"./KotR-SDM-WoS-Int-1-EPUB-cover-fromID.jpg": 3324,
	"./KotR-SDM-WoS-Int-2-EPUB-cover-fromID.jpg": 6747,
	"./KotR-SDM-banner-no-books.jpg": 8609,
	"./KotR-SDm-banner-with-books.jpg": 2792,
	"./KotR-WoS-banner-no-books.jpg": 2262,
	"./KotR-WoS-banner-with-book.jpg": 4722,
	"./KotR-new-book-banner-no-book.jpg": 7998,
	"./KotR-series.jpg": 9472,
	"./KotR-standalone-Prequels-banner-no-books.jpg": 8288,
	"./KotR-standalone-prequels-banner-with-books.jpg": 7493,
	"./KotR1-Back-Blurb.jpg": 5111,
	"./KotR1-COVER.jpg": 2829,
	"./KotR2-Back-Blurb.jpg": 150,
	"./KotR2-COVER.jpg": 7766,
	"./KotR3-Kalapula-HJ2-Back-Blurb.jpg": 1252,
	"./KotR3-Kalapula-HJ2-COVER.jpg": 5984,
	"./KotR4-HJ3-Back-Blurb.jpg": 6614,
	"./KotR4-HJ3-COVER.jpg": 9094,
	"./KotR5-SDM1-Cover.jpg": 4923,
	"./KotR5-SDM1-back-blurb.jpg": 3761,
	"./KotR6-SDM2-back-blurb.jpg": 3587,
	"./KotR6-SDM2-cover.jpg": 2369,
	"./KotR7-SDM3-COVER-placeholder.jpg": 5699,
	"./KotR7-SDM3-back-blurb.jpg": 3901,
	"./KotRMAin-4-WoS-1-squiggle.jpg": 7146,
	"./KotRMain-1-SDM1-EPUB-cover-fromID.jpg": 1026,
	"./KotRMain-2-SDM2-EPUB-cover-fromID.jpg": 9360,
	"./KotRMain-3-SDM3-EPUB-cover-fromID.jpg": 8462,
	"./KotRMain-4-WoS-1-EPUB-cover-fromID.jpg": 9089,
	"./KotRMain-5-WoS-2-cover-fromID.jpg": 6708,
	"./KotRMain-6-WoS-3-EPUB-cover-fromID.jpg": 7861,
	"./KotRP-FoT-Back-Blurb.jpg": 7416,
	"./KotRP-FoT-COVER.jpg": 2444,
	"./KotRP-FoT-EPUB-cover-fromID.jpg": 3435,
	"./KotRP-KotR1-EPUB-cover-fromID.jpg": 1241,
	"./KotRP-OotW-EPUB-cover-fromID.jpg": 5709,
	"./KotRP-SC-Back-Blurb.jpg": 271,
	"./KotRP-SC-Cover.jpg": 5637,
	"./KotRP-SC-EPUB-cover-fromID.jpg": 9090,
	"./KotRP2-HJ1-EPUB-cover-fromID.jpg": 2411,
	"./KotRP3-HJ2-EPUB-cover-fromID.jpg": 4361,
	"./KotRP4-HJ3-EPUB-cover-fromID.jpg": 355,
	"./MAP-Brelsin.jpg": 9096,
	"./MAP-Dawil.jpg": 7312,
	"./MAP-Ilseador.jpg": 3120,
	"./MAP-MerutianSea-DIPZA.jpg": 7406,
	"./MAP-MerutianSea-fromKotR3-HJ2.jpg": 6081,
	"./MAP-Pathremir-Daffyds.jpg": 4043,
	"./MAP-TallspireFromSide.jpg": 9068,
	"./MAP-TallspireFromTop.jpg": 6864,
	"./MAP-Taridawil-with-vassal-fiefs.jpg": 5220,
	"./Map-Taridawil.jpg": 5210,
	"./PP-PP-series-narrow.jpg": 2045,
	"./PP-PP-series-wide.jpg": 2365,
	"./PP-RWS-series-narrow.jpg": 3181,
	"./PP-RWS-series-wide.jpg": 1005,
	"./PP-series.jpg": 2364,
	"./PP6-COVER.jpg": 4886,
	"./RDB-Logo-PurpleGold.jpg": 567,
	"./Senili-silver-no-bkgd.png": 9319,
	"./Thony1-Back-Blurb.jpg": 4397,
	"./Thony1-COVER.jpg": 9823,
	"./Thony2-Back-Blurb.jpg": 3192,
	"./Thony2-COVER.jpg": 9036,
	"./Thony3-Back-Blurb.jpg": 1219,
	"./Thony3-COVER.jpg": 8433,
	"./Thony4-Back-Blurb.jpg": 2982,
	"./Thony4-COVER.jpg": 3574,
	"./Thony5-Back-Blurb.jpg": 4545,
	"./Thony5-COVER.jpg": 1819,
	"./Thony6-Back-Blurb.jpg": 3692,
	"./TimeLine.xlsx": 4446,
	"./Website-2nd-banner-long.jpg": 6500,
	"./Website-top-banner-long.jpg": 2253,
	"./Website-top-banner.jpg": 5396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;